import consts from "@/consts.js";
import Request from './request';

async function fetchOne(id) {// 获取单个
    return Request('get', "api/material-categories/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/material-categories", data);
}

async function tree(data) {
    return Request('get', "api/material-categories/tree", data);
}

async function quotationTree(data) {
    return Request('get', "api/supplier-material-categories/tree", data);
}

async function save(id,data){// 编辑或新建数据（有id为编辑，没有id为新建）
    if(id){
        return Request('post', "api/material-categories/edit?id=" + id, data);
    } else {
        return Request('post', "api/material-categories/add" , data);
    }
}

async function del(id){// 删除数据
    return Request('get', "api/material-categories/delete/", id ? { id: id} : {});
}

export default {
    fetchOne,
    fetchAll,
    tree,
    save,
    del,
    quotationTree
};